import { MaskEditState } from './types';

export const EMPTY_MASK_EDIT_STATE: MaskEditState = {
  canReset: false,
  hasPendingChanges: false,
  isMaskSelected: false,
};
